import i18n from "../i18n";

const Stores = (app) => {
  app
    .post("/stores/save/:id?", async ({ api, flash, req, res }) => {
      const { body, files, params } = req;

      await api(`widget-store${params.id ? `/${params.id}` : ""}`, {
        method: params.id ? "PUT" : "POST",
        body,
        files,
      }).then((response) => {
        if (response.status === 200 || response.status === 201)
          flash(
            "success",
            i18n.t("coaching-portal:storesActions.successfullySaved")
          );
        else {
          flash(
            "error",
            response.statusText ||
              i18n.t("coaching-portal:storesActions.error")
          );
          res.refreshWith({}, { url: "back", hash: "#_" });
        }
      });

      res.refreshWith(
        { modal: "", store: "", submited: true },
        { url: "back", hash: "#_" }
      );
    })
    .get("/stores/delete/:id", async ({ api, flash, req, res }) => {
      const { id } = req.params;

      await api(`widget-store/${id}`, {
        method: "DELETE",
      });

      flash(
        "success",
        i18n.t("coaching-portal:storesActions.successfullyRemoved")
      );

      res.backDontScroll();
    })
    .post("/stores/reorder", async ({ api, assert, flash, req, res }) => {
      const { body } = req;
      assert(
        body.orderedStores,
        400,
        i18n.t("coaching-portal:storesActions.provideOrderedStores")
      );

      await api("widget-store-reorder", {
        method: "PUT",
        body,
      });

      flash(
        "success",
        i18n.t("coaching-portal:storesActions.successfullyReordered")
      );
      res.backDontScroll();
    })

    .post("/stores/push-invite/", async ({ req, res, flash, api }) => {
      const { body } = req;
      await api(`push-invite`, {
        method: "POST",
        body,
      });

      flash(
        "success",
        i18n.t("coaching-portal:storesActions.invitationSent")
      );

      res.refreshWith(
        { modal: "", email: "" },
        { url: "/coaching-portal/store", hash: "#_" }
      );
    })

    .post("/stores/status/:id", async ({ api, assert, flash, req, res }) => {
      const {
        body: { status },
        params: { id },
      } = req;
      const verbs = {
        draft: "unpublish",
        published: "publish",
      };

      assert(
        status,
        400,
        i18n.t("coaching-portal:storesActions.statusRequired")
      );
      assert(
        id,
        400,
        i18n.t("coaching-portal:storesActions.playlistIdRequired")
      );

      const verb = verbs[status];

      if (
        process.browser &&
        !confirm(
          i18n.t("coaching-portal:storesActions.confirmVerbPlaylist", { verb })
        )
      ) {
        return res.backDontScroll();
      }

      await api(`widget-store/${id}`, {
        method: "PUT",
        body: { status },
      });

      flash(
        "success",
        i18n.t("coaching-portal:storesActions.successfullyVerbed", { verb })
      );

      res.refreshWith({}, { url: "back", hash: "#_" });
    });
};

export default Stores;
